/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeactivatePrescriptionRequestBody = {
  expectedVersion: number;
  operationId: string;
  organizationId: string;
  prescriptionId: string;
};

/** @internal */
export type DeactivatePrescriptionRequestBody$Outbound = {
  expected_version: number;
  operation_id: string;
  organization_id: string;
  prescription_id: string;
};

/** @internal */
export const DeactivatePrescriptionRequestBody$outboundSchema: z.ZodMiniType<
  DeactivatePrescriptionRequestBody$Outbound,
  DeactivatePrescriptionRequestBody
> = z.pipe(
  z.object({
    expectedVersion: z.int(),
    operationId: z.string(),
    organizationId: z.string(),
    prescriptionId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      expectedVersion: "expected_version",
      operationId: "operation_id",
      organizationId: "organization_id",
      prescriptionId: "prescription_id",
    });
  }),
);

export function deactivatePrescriptionRequestBodyToJSON(
  deactivatePrescriptionRequestBody: DeactivatePrescriptionRequestBody,
): string {
  return JSON.stringify(
    DeactivatePrescriptionRequestBody$outboundSchema.parse(
      deactivatePrescriptionRequestBody,
    ),
  );
}
